import jquery from 'jquery';

// lodash
import _castArray from 'lodash/castArray';
import _compact from 'lodash/compact';
import _pick from 'lodash/pick';
import _size from 'lodash/size';

var Config = function() {
  var self = this;

  self.config = self._getConfig();
};

/**
 * @private
 *
 * @description
 * Тянем настройки магаза из меты
 *
 * @return {Object} - настройки
 */
Config.prototype._getConfig = function() {
  var _config = {};

  _config = jquery('[name="page-config"]').data('config');

  return _config;
};

/**
 * @private
 * Получение конфига
 *
 * @param {String|Array|null} _fields - список полей, которые надо вернуть.
 *
 * @return {Object}
 * возвращает список полей и их значений. если указывалось только одно поле - возвращается только его значение.
 */
Config.prototype.get = function(_fields) {
  var self = this;
  var _fieldsCount = [];
  var result = {};

  _fieldsCount = _size(_compact(_castArray(_fields)));

  if (_fieldsCount) {
    result = _pick(self.config, _fields);
  } else {
    result = self.config;
  }

  return result;
};

export default Config;
